/*
 * Checkbox
 */

const attachCheckbox = (node) => {};

const createCheckbox = (attributes) => {};

const razorCheckbox = {
  selector: ".a-checkbox",
  create: createCheckbox,
  attach: attachCheckbox,
};

export default razorCheckbox;
